export const getFeaturesCtaTexts = (gettext: (key: string) => string) =>
    ({
        pp: {
            title: gettext('Personal Plan was made to move careers'),
            cta: {
                title: gettext(
                    'Get 30 days of unlimited learning on Personal Plan free (monthly pricing applies thereafter). Limited time offer.',
                ),
                buttonText: gettext('Get started'),
                url: '/subscription-checkout/express?utm_campaign=indeed',
            },
        },
        mx: {
            title: gettext('Learning that moves your career'),
            cta: {
                title: gettext(
                    'Add new skills to your resume with courses in AI, data science, personal development, and more.',
                ),
                buttonText: gettext('Explore Now'),
                url: '/featured-topics/',
            },
        },
    }) as const;
